module.exports = __webpack_public_path__ + "media/images/svg/advertisement-acefe5c65e262b27b4c84c0bbe3bcda1.svg";